import { render } from "./NormalLayout.vue?vue&type=template&id=2c3fb95f"
import script from "./NormalLayout.vue?vue&type=script&lang=js"
export * from "./NormalLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/sites/fcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/member/views/layouts/NormalLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c3fb95f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c3fb95f', __exports__)) {
    console.log('reload')
    api.reload('2c3fb95f', __exports__)
  }
  
  module.hot.accept("./NormalLayout.vue?vue&type=template&id=2c3fb95f", () => {
    console.log('re-render')
    api.rerender('2c3fb95f', render)
  })

}


export default __exports__